import styled from 'styled-components';
import { getGridSpans, getSpace, getColor, borderShape } from '../../../stylesheets/tools';

const StyledSocialPost = styled.div`
  position: relative;
  min-height: 200px;

  ${getGridSpans('margin-left', { s: [1, 'spread'], m: [2, 'spread'] })};

  .social-post__overlay {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100%;
    background: #fff;
    ${borderShape()}
    text-align: left;

    p {
      padding: 0 ${getSpace('m')};
    }
  }

  .social-post__overlay-button {
    position: relative;
    width: 100%;
    height: 100%;
    display: block;
    margin: ${getSpace('xs')} 0;
    text-align: center;
    color: ${getColor('black')};
  }

  .social-post__headline {
    position: relative;
    display: block;
    width: 100%;
    text-transform: uppercase;
    bottom: 0;
    left: 0;
    margin-top: ${getSpace('m')};
    padding: ${getSpace('m')} ${getSpace('m')} 0;

    &:before {
      position: absolute;
      content: '';
      width: 50px;
      height: 2px;
      top: 0px;
      left: -25px;
      background: #000;
    }
  }

  .social-post__privacy-protection {
    text-decoration: underline;
  }

  iframe.instagram-media {
    min-width: auto !important;
  }

  .fb-post > span {
    width: 100% !important;
  }

  .fb-post iframe {
    width: 100% !important;
    min-width: auto !important;
    max-width: 522px !important;
  }
`;

export default StyledSocialPost;
